import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "inline-flex items-center gap-x-1.5 rounded-full bg-orange-100 px-2 py-1 text-xs font-medium text-orange-600 max-w-max min-w-0"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("svg", {
  class: "h-1.5 w-1.5 fill-orange-400",
  viewBox: "0 0 6 6",
  "aria-hidden": "true"
}, [
  /*#__PURE__*/_createElementVNode("circle", {
    cx: "3",
    cy: "3",
    r: "3"
  })
], -1)
const _hoisted_3 = { class: "truncate" }
const _hoisted_4 = {
  key: 2,
  class: "truncate"
}
const _hoisted_5 = { class: "text-gray-500 text-xs truncate" }
const _hoisted_6 = { class: "text-gray-500 text-xs truncate" }
const _hoisted_7 = { class: "flex items-center justify-end gap-1 min-w-0" }
const _hoisted_8 = { class: "flex gap-2 justify-end" }

import { TrashIcon, PencilIcon } from "@heroicons/vue/24/solid";
import { computed, ref } from "vue";
import { useI18n } from "vue-i18n";
import { Organization } from "shared/types/Organization";
import { User, UserOrganizationPermissionGroup } from "shared/types/User";
import EditOrganizationPermissionModal from "@/components/users/EditOrganizationPermissionModal.vue";
import RemoveUserModal from "@/components/users/RemoveUserModal.vue";
import { calculateIndentation } from "@/views/organizations/organizations";


export default /*#__PURE__*/_defineComponent({
  __name: 'OrganizationTabUsersItem',
  props: {
    user: {},
    organization: {},
    canEdit: { type: Boolean },
    showCompanyTypeBadge: { type: Boolean },
    indentation: { default: 0 },
    cls: {}
  },
  setup(__props: any) {

const permissionLabelsColors: Partial<Record<UserOrganizationPermissionGroup, string>> = {
  organization_admin: "bg-green-100 text-green-800",
};

const permissionSortOrder: Record<UserOrganizationPermissionGroup, number> = {
  organization_base: 1,
  organization_admin: 2,
};

const props = __props;

const { t } = useI18n();

const isDeleteUserModalOpen = ref(false);
const isEditOrganizationPermissionModalOpen = ref(false);

const userGroups = computed(() => {
  const userOrganization = props.user.organizations.find(
    (user) => user.organization_id === props.organization._id,
  );
  if (!userOrganization) {
    return [];
  }
  return userOrganization.explicit_groups
    .filter((group) => group !== "organization_base")
    .sort((a, b) => permissionSortOrder[a] - permissionSortOrder[b]);
});

const companyType = computed(
  () =>
    props.user.organizations.find(
      (organization) => organization.organization_id === props.organization._id,
    )?.company_type,
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["grid gap-4 items-center hover:bg-gray-100 px-4 relative h-[50px]", _ctx.cls]),
    style: _normalizeStyle({
      gridTemplateColumns: '1fr 1fr 1fr 1fr 40px',
      paddingLeft: `${_unref(calculateIndentation)(_ctx.indentation)}px`,
    })
  }, [
    (companyType.value && _ctx.showCompanyTypeBadge)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "absolute -top-[9px] left-0 text-[10px] font-semibold bg-white rounded px-2 border truncate",
          style: _normalizeStyle({ marginLeft: `${_unref(calculateIndentation)(_ctx.indentation)}px` })
        }, _toDisplayString(_unref(t)(`admin.project_participants.company_types.${companyType.value}`)), 5))
      : _createCommentVNode("", true),
    (_ctx.user.user_status !== 'confirmed')
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _hoisted_2,
          _createElementVNode("span", _hoisted_3, _toDisplayString(_unref(t)("admin.project_participants.pending_invite")), 1)
        ]))
      : _createCommentVNode("", true),
    (_ctx.user.user_status === 'confirmed')
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_ctx.user.name), 1))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.user.email), 1),
    _createElementVNode("div", _hoisted_6, _toDisplayString(props.user.role ? _unref(t)(`admin.project_participants.user_roles.${props.user.role}`) : ""), 1),
    _createElementVNode("div", _hoisted_7, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(userGroups.value, (permission) => {
        return (_openBlock(), _createElementBlock("div", {
          key: permission,
          class: _normalizeClass(["rounded-full px-2 text-xs font-semibold truncate", permissionLabelsColors[permission] ?? 'bg-yellow-300 text-yellow-800'])
        }, _toDisplayString(_ctx.$t(`permissions.${permission}`)), 3))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_8, [
      (_ctx.canEdit)
        ? (_openBlock(), _createBlock(_unref(PencilIcon), {
            key: 0,
            class: "w-4 h-4 shrink-0 text-gray-400 cursor-pointer hover:text-gray-500",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (isEditOrganizationPermissionModalOpen.value = true))
          }))
        : _createCommentVNode("", true),
      (_ctx.canEdit)
        ? (_openBlock(), _createBlock(_unref(TrashIcon), {
            key: 1,
            class: "w-4 h-4 shrink-0 text-gray-400 cursor-pointer hover:text-gray-500",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (isDeleteUserModalOpen.value = true))
          }))
        : _createCommentVNode("", true)
    ]),
    (isDeleteUserModalOpen.value)
      ? (_openBlock(), _createBlock(RemoveUserModal, {
          key: 3,
          user: _ctx.user,
          organizationId: _ctx.organization._id,
          onClose: _cache[2] || (_cache[2] = ($event: any) => (isDeleteUserModalOpen.value = false))
        }, null, 8, ["user", "organizationId"]))
      : _createCommentVNode("", true),
    (isEditOrganizationPermissionModalOpen.value)
      ? (_openBlock(), _createBlock(EditOrganizationPermissionModal, {
          key: 4,
          user: _ctx.user,
          organizationId: _ctx.organization._id,
          onClose: _cache[3] || (_cache[3] = ($event: any) => (isEditOrganizationPermissionModalOpen.value = false))
        }, null, 8, ["user", "organizationId"]))
      : _createCommentVNode("", true)
  ], 6))
}
}

})